import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';

function Header({ onMenuToggle }) {
  const { pathname } = useLocation();

  return (
    <header id="masthead" className="site-header headerone">
      <div className="nav-classic header-main">
        <div className="header-middle-inner" style={{ padding: '0 15px' }}>
                <div className="site-branding">
                  <div className="brandinglogo-wrap">
                    <Link to="/" className="custom-logo-link">
                      <img src={logo} width="182" height="26" alt="DLA STRUCTURE" />
                    </Link>
                    <p className="site-description">QUALITE SECURITE FIABILITE</p>
                  </div>
                  <button className="toggle nav-toggle mobile-nav-toggle" onClick={onMenuToggle}>
                    <span className="toggle-inner">
                      <span className="toggle-icon"><i className="fas fa-bars"></i></span>
                      <span className="toggle-text">Menu</span>
                    </span>
                  </button>
                </div>
                <div className="nav-menu hide-on-mobile-disable">
                  <Link to="/" className={pathname === '/' ? 'active' : ''}>Accueil</Link>
                  <Link to="/presentation" className={pathname === '/presentation' ? 'active' : ''}>Présentation</Link>
                  <Link to="/prestations" className={pathname === '/prestations' ? 'active' : ''}>Prestations</Link>
                  <Link to="/projets" className={pathname === '/projets' ? 'active' : ''}>Projets</Link>
                  <Link to="/bim" className={pathname === '/bim' ? 'active' : ''}>BIM</Link>
                  <Link to="/contact" className={pathname === '/contact' ? 'active' : ''}>Contact</Link>
                  <a href="javascript:void(0)" className="searchicon"><i className="fas fa-search"></i></a>
                </div>
              </div>
            </div>
    </header>
  );
}

export default Header;

